import script from "./ManutOsSolicitacaoPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ManutOsSolicitacaoPage.vue?vue&type=script&setup=true&lang=js"

import "./ManutOsSolicitacaoPage.vue?vue&type=style&index=0&id=13d51a4e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13d51a4e"]])

export default __exports__